import { useMsal } from '@azure/msal-react';
import { zodResolver } from '@hookform/resolvers/zod';
import LoadingButton from '@mui/lab/LoadingButton';
import { Button } from '@mui/material';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';

import { loginRequest } from '@/authConfig';
import HookFormInput from '@/components/HookFormInput';
import { usePostData } from '@/helpers/hooks';

const EmailSSOLoginForm = () => {
  const { instance, inProgress } = useMsal();

  const formSchema = z.object({
    email: z.string().email().min(1, 'Please provide your email.')
  });
  type FormFields = z.infer<typeof formSchema>;

  const methods = useForm<FormFields>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    resolver: zodResolver(formSchema),
    defaultValues: { email: '' }
  });

  const validateEmailMutate = usePostData<string, any, { email: string }>({
    url: '/login/VerifyEmail'
  });

  const { handleSubmit } = methods;

  const onSubmit = async (data: FormFields) => {
    await validateEmailMutate.mutateAsync({
      email: data.email
    });
    await instance.loginRedirect(loginRequest(data.email));
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} id='email-sso-login-form' className='space-y-4'>
        <HookFormInput
          name='email'
          label='Email address'
          variant='filled'
          disabled={inProgress !== 'none'}
          sx={{
            '& .MuiInputBase-root': {
              height: '54px',
              backgroundColor: 'transparent',
              borderRadius: '8px',
              '& fieldset': {
                border: '1px solid white'
              }
            }
          }}
        />
        <div className='flex justify-end'>
          <LoadingButton
            className='h-[30px] w-[120px] !rounded-[0px] !bg-[#0067B8] text-white'
            type={'submit'}
            form='email-sso-login-form'
            variant={'contained'}
            loading={inProgress !== 'none'}
          >
            Continue
          </LoadingButton>
        </div>
      </form>
    </FormProvider>
  );
};

export default EmailSSOLoginForm;
